export const detailLightTheme = {
  '--ant-collapse-header': '#EEEEEE',
  '--ant-collapse-header-tltle': '#333333',
  '--ant-collapse-content-border': '#EEEEEE',
  '--description-box-container': '#333333',
  '--icon-favorites-heart': '#999999',
  '--sell-ant-table-cell-fix-right': '#ffffff',
  '--ant-collapse-content': '#EEEEEE',
  '--modal-pic-container': '#EEEEEE',
  '--detail-button-container': '#E2F7FF',
  '--show-box-item': '#ffffff',
  '--hashBox': '#f8f8f8',
}
export const detailDarkTheme = {
  '--ant-collapse-header': '#23262f',
  '--ant-collapse-header-tltle': '#ffffff',
  '--ant-collapse-content-border': '#222e3d',
  '--description-box-container': '#9fa7b3',
  '--icon-favorites-heart': '#ffffff',
  '--sell-ant-table-cell-fix-right': '#141417',
  '--ant-collapse-content': '#2c3038',
  '--modal-pic-container': '#000000',
  '--detail-button-container': '#23262f',
  '--show-box-item': '#23262f',
  '--hashBox': '#3d414d',
}
